const creditEvaluation = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/creditEvaluation/creditEvaluation')),
    'creditEvaluation'
  );
const creditEvaluationRouterIndex = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/creditEvaluation/creditEvaluationRouterIndex')),
    'creditEvaluationRouterIndex'
  );
const creditEvaluationIndex = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/creditEvaluationIndex/creditEvaluationIndex')
      ),
    'creditEvaluationIndex'
  );
const creditEvaluationManageIndex = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/creditEvaluationIndex/creditEvaluationManageIndex')
      ),
    'creditEvaluationManageIndex'
  );

// 项目负责人相关页面
const managerInfo = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/creditEvaluation/managerPage/managerInfo')),
    'managerInfo'
  );
const managerGoodInfoList = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/creditEvaluation/managerPage/managerGoodInfoList')),
    'managerGoodInfoList'
  );
const managerBadInfoList = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/creditEvaluation/managerPage/managerBadInfoList')),
    'managerBadInfoList'
  );
const managerGoodInfoDetails = (r) =>
  require.ensure(
    [],
    () =>
      r(require('@/page/creditEvaluation/managerPage/managerGoodInfoDetails')),
    'managerGoodInfoDetails'
  );
const managerBadInfoDetails = (r) =>
  require.ensure(
    [],
    () =>
      r(require('@/page/creditEvaluation/managerPage/managerBadInfoDetails')),
    'managerBadInfoDetails'
  );
// 物业服务企业相关页面
const companyAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/creditEvaluation/companyPage/companyAdd')),
    'companyAdd'
  );
const companyApplyRecordList = (r) =>
  require.ensure(
    [],
    () =>
      r(require('@/page/creditEvaluation/companyPage/companyApplyRecordList')),
    'companyApplyRecordList'
  );
const companyApplyGoodDetails = (r) =>
  require.ensure(
    [],
    () =>
      r(require('@/page/creditEvaluation/companyPage/companyApplyGoodDetails')),
    'companyApplyGoodDetails'
  );
const companyBaseInfoDetails = (r) =>
  require.ensure(
    [],
    () =>
      r(require('@/page/creditEvaluation/companyPage/companyBaseInfoDetails')),
    'companyBaseInfoDetails'
  );
const companyBaseInfoCommunity = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/companyPage/companyBaseInfoCommunity')
      ),
    'companyBaseInfoCommunity'
  );
const companyManagerList = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/creditEvaluation/companyPage/companyManagerList')),
    'companyManagerList'
  );
const companyObjectionAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/creditEvaluation/companyPage/companyObjectionAdd')),
    'companyObjectionAdd'
  );
const companyObjectionDetails = (r) =>
  require.ensure(
    [],
    () =>
      r(require('@/page/creditEvaluation/companyPage/companyObjectionDetails')),
    'companyObjectionDetails'
  );
const companyApplyIncentiveList = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/companyPage/companyApplyIncentiveList')
      ),
    'companyApplyIncentiveList'
  );
const companyApplyIncentiveDetails = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/companyPage/companyApplyIncentiveDetails')
      ),
    'companyApplyIncentiveDetails'
  );

// 主管部门关页面
// 新增审核事项
const approveList = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/creditEvaluation/approvePage/approveList')),
    'approveList'
  );
const approveRevokeGood = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveAddMatter/approveRevokeGood')
      ),
    'approveRevokeGood'
  );
const approveDeleteGood = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveAddMatter/approveDeleteGood')
      ),
    'approveDeleteGood'
  );
// const approveHistoryDelect = (r) =>
//   require.ensure(
//     [],
//     () =>
//       r(
//         require('@/page/creditEvaluation/approvePage/approveAddMatter/approveHistoryDelect')
//       ),
//     'approveHistoryDelect'
//   );
const approveAddBad = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveAddMatter/approveAddBad')
      ),
    'approveAddBad'
  );
const approveAddGood = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveAddMatter/approveAddGood')
      ),
    'approveAddGood'
  );
const approveRevokeBad = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveAddMatter/approveRevokeBad')
      ),
    'approveRevokeBad'
  );
const approveRepairBad = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveAddMatter/approveRepairBad')
      ),
    'approveRepairBad'
  );
const approveAddRiskList = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveAddMatter/approveAddRiskList')
      ),
    'approveAddRiskList'
  );
// 审核流程
const approveProcessGoodCognizance = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveProcess/approveProcessGoodCognizance')
      ),
    'approveProcessGoodCognizance'
  );
const approveProcessGoodRevoke = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveProcess/approveProcessGoodRevoke')
      ),
    'approveProcessGoodRevoke'
  );
const approveProcessGoodDelete = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveProcess/approveProcessGoodDelete')
      ),
    'approveProcessGoodDelete'
  );
const approveProcessBadInput = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveProcess/approveProcessBadInput')
      ),
    'approveProcessBadInput'
  );
const approveProcessBadRevoke = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveProcess/approveProcessBadRevoke')
      ),
    'approveProcessBadRevoke'
  );
const approveProcessBadRepair = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveProcess/approveProcessBadRepair')
      ),
    'approveProcessBadRepair'
  );
const approveProcessRiskList = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveProcess/approveProcessRiskList')
      ),
    'approveProcessRiskList'
  );

  const approveBatchRiskList = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveProcess/approveBatchRiskList')
      ),
    'approveBatchRiskList'
  );
// 审核异议
const approveGoodDissent = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveDissent/approveGoodDissent')
      ),
    'approveGoodDissent'
  );
const approveGoodScorDissent = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveDissent/approveGoodScorDissent')
      ),
    'approveGoodScorDissent'
  );
const approveBadScorDissent = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveDissent/approveBadScorDissent')
      ),
    'approveBadScorDissent'
  );
const approveRiskListDissent = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveDissent/approveRiskListDissent')
      ),
    'approveRiskListDissent'
  );
// 审核事项查询
const approveEventQuery = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveEventQuery/approveEventQuery')
      ),
    'approveEventQuery'
  );
const approveEventDetails = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveEventQuery/approveEventDetails')
      ),
    'approveEventDetails'
  );
// 基础信息管理
const approveCompanyList = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveBasInfoList/approveCompanyList')
      ),
    'approveCompanyList'
  );
const approveCompanyDetails = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveBasInfoList/approveCompanyDetails')
      ),
    'approveCompanyDetails'
  );
const approveManagerList = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveBasInfoList/approveManagerList')
      ),
    'approveManagerList'
  );
const approveManagerDetails = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveBasInfoList/approveManagerDetails')
      ),
    'approveManagerDetails'
  );
// 良好信息管理
const approveGoodInfoList = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveGoodInfoList/approveGoodInfoList')
      ),
    'approveGoodInfoList'
  );
const approveGoodInfoDetails = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveGoodInfoList/approveGoodInfoDetails')
      ),
    'approveGoodInfoDetails'
  );
const approveGoodInfoHistory = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveGoodInfoList/approveGoodInfoHistory')
      ),
    'approveGoodInfoHistory'
  );
// 不良信息管理
const approveBadInfoList = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveBadInfoList/approveBadInfoList')
      ),
    'approveBadInfoList'
  );
const approveBadInfoDetails = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveBadInfoList/approveBadInfoDetails')
      ),
    'approveBadInfoDetails'
  );
const approveBadInfoHistory = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveBadInfoList/approveBadInfoHistory')
      ),
    'approveBadInfoHistory'
  );
// 风险名单
const approveCompanyRiskList = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveRiskList/approveCompanyRiskList')
      ),
    'approveCompanyRiskList'
  );
const approveCompanyRiskDetails = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveRiskList/approveCompanyRiskDetails')
      ),
    'approveCompanyRiskDetails'
  );
const approveManagerRiskList = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveRiskList/approveManagerRiskList')
      ),
    'approveManagerRiskList'
  );
const approveManagerRiskDetails = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveRiskList/approveManagerRiskDetails')
      ),
    'approveManagerRiskDetails'
  );
  const pendingRiskMge = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveRiskList/pendingRiskMge/pendingRiskMge')
      ),
    'pendingRiskMge'
  );
  const riskListMge = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveRiskList/pendingRiskMge/riskListMge')
      ),
    'riskListMge'
  );
  const pendingRiskDetail = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveRiskList/pendingRiskMge/pendingRiskDetail')
      ),
    'pendingRiskDetail'
  );
//激励名单
const approveIncentiveList = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/approveIncentiveList/approveIncentiveList')
      ),
    'approveIncentiveList'
  );
const incentiveManagement = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/incentiveManagement/incentiveManagement')
      ),
    'incentiveManagement'
  );
const incentiveManagementProcess = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/incentiveManagement/incentiveManagementProcess')
      ),
    'incentiveManagementProcess'
  );
const incentiveWinChange = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/incentiveManagement/incentiveWinChange')
      ),
    'incentiveWinChange'
  );
const publicityPreview = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/incentiveManagement/publicityPreview')
      ),
    'publicityPreview'
  );
const incentiveCompanyDetails = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/approvePage/incentiveManagement/incentiveCompanyDetails')
      ),
    'incentiveCompanyDetails'
  );

// 计分规则
const goodScoringRulesList = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/scoringRulesPage/goodScoringRulesList')
      ),
    'goodScoringRulesList'
  );
const badScoringRulesList = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/scoringRulesPage/badScoringRulesList')
      ),
    'badScoringRulesList'
  );
const addEditGoodScoringRules = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/scoringRulesPage/addEditGoodScoringRules')
      ),
    'addEditGoodScoringRules'
  );
const addEditBadScoringRules = (r) =>
  require.ensure(
    [],
    () =>
      r(
        require('@/page/creditEvaluation/scoringRulesPage/addEditBadScoringRules')
      ),
    'addEditBadScoringRules'
  );
// 审核流程配置
const matterList = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/creditEvaluation/processConfigPage/matterList')),
    'matterList'
  );
const addMatterRules = (r) =>
  require.ensure(
    [],
    () =>
      r(require('@/page/creditEvaluation/processConfigPage/addMatterRules')),
    'addMatterRules'
  );
const processList = (r) =>
  require.ensure(
    [],
    () => r(require('@/page/creditEvaluation/processConfigPage/processList')),
    'processList'
  );
const addProcessRules = (r) =>
  require.ensure(
    [],
    () =>
      r(require('@/page/creditEvaluation/processConfigPage/addProcessRules')),
    'addProcessRules'
  );
const entrustedAgency = (r) =>
  require.ensure(
    [],
    () =>
      r(require('@/page/creditEvaluation/processConfigPage/entrustedAgency')),
    'entrustedAgency'
  );
// userType: 1: 物业企业 2： 项目负责人 3： 主管部门 4：市局用户 5：市局用户-负责人

const creditEvaluationRouter = {
  path: '',
  name: '物业服务信息评价',
  component: creditEvaluation,
  meta: {
    icon: 'committeeRecord',
    userType: 3,
    right: [],
    isShowMenu: true,
    keepAlive: true,
  },
  children: [
    {
      path: '/creditEvaluationIndex',
      component: creditEvaluationIndex,
      name: '物业服务信息评价',
      meta: {
        userType: 1,
        right: ['物业服务信息评价'],
        isShowMenu: true,
        keepAlive: false,
      },
    },
    {
      path: '/creditEvaluationManageIndex',
      component: creditEvaluationManageIndex,
      name: '物业服务信息评价',
      meta: {
        userType: 2,
        right: ['物业服务信息评价'],
        isShowMenu: true,
        keepAlive: false,
      },
    },
    // 项目负责人相关页面
    {
      path: '/managerInfo',
      component: managerInfo,
      name: '项目负责人基础信息',
      meta: {
        userType: 2,
        right: ['项目负责人基础信息'],
        isShowMenu: true,
        keepAlive: false,
      },
    },
    {
      path: '/managerGoodInfoList',
      component: managerGoodInfoList,
      name: '良好信息',
      meta: {
        userType: 2,
        right: ['良好信息'],
        isShowMenu: true,
        keepAlive: true,
      },
    },
    {
      path: '/managerGoodInfoDetails',
      component: managerGoodInfoDetails,
      name: '良好信息详情',
      meta: {
        userType: 2,
        right: ['良好信息详情'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    {
      path: '/managerBadInfoList',
      component: managerBadInfoList,
      name: '不良信息',
      meta: {
        userType: 2,
        right: ['不良信息'],
        isShowMenu: true,
        keepAlive: true,
      },
    },
    {
      path: '/managerBadInfoDetails',
      component: managerBadInfoDetails,
      name: '不良信息详情',
      meta: {
        userType: 2,
        right: ['不良信息详情'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    // 物业服务企业相关页面
    {
      path: '/companyAdd',
      component: companyAdd,
      name: '申报良好信息',
      meta: {
        userType: 1,
        right: ['申报良好信息'],
        isShowMenu: true,
      },
    },
    // {
    //   path: '/IncentiveList',
    //   component: IncentiveList,
    //   name: '申请激励名单',
    //   meta: {
    //       userType: 1,
    //       right: ['申请激励名单'],
    //       isShowMenu: true,
    //   },
    // },
    // {
    //   path: '/IncentiveListIndex',
    //   component: IncentiveListIndex,
    //   name: '激励名单审核',
    //   meta: {
    //       userType: 1,
    //       right: ['激励名单审核'],
    //       isShowMenu: true,
    //   },
    // },
    {
      path: '/companyApplyRecordList',
      component: companyApplyRecordList,
      name: '我的申请记录',
      meta: {
        userType: 1,
        right: ['我的申请记录'],
        isShowMenu: true,
        keepAlive: true,
      },
    },
    {
      path: '/companyApplyGoodDetails',
      component: companyApplyGoodDetails,
      name: '申请详情',
      meta: {
        userType: 1,
        right: ['申请详情'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    {
      path: '/companyBaseInfoDetails',
      component: companyBaseInfoDetails,
      name: '基本信息详情',
      meta: {
        userType: 1,
        right: ['基本信息详情'],
        isShowMenu: true,
        keepAlive: true,
      },
    },
    {
      path: '/companyBaseInfoCommunity',
      component: companyBaseInfoCommunity,
      name: '基本信息详情小区穿透',
      meta: {
        userType: 1,
        right: ['基本信息详情小区穿透'],
        isShowMenu: true,
        keepAlive: false,
      },
    },
    {
      path: '/companyManagerList',
      component: companyManagerList,
      name: '项目负责人管理',
      meta: {
        userType: 1,
        right: ['项目负责人管理'],
        isShowMenu: true,
        keepAlive: true,
      },
    },
    {
      path: '/companyObjectionAdd',
      component: companyObjectionAdd,
      name: '申请异议',
      meta: {
        userType: 1,
        right: ['申请异议'],
        isShowMenu: true,
        keepAlive: true,
      },
    },
    {
      path: '/companyObjectionDetails',
      component: companyObjectionDetails,
      name: '申请异议详情',
      meta: {
        userType: 1,
        right: ['申请异议详情'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    {
      path: '/companyApplyIncentiveList',
      component: companyApplyIncentiveList,
      name: '申报激励名单',
      meta: {
        userType: 1,
        right: ['申报激励名单'],
        isShowMenu: true,
        keepAlive: false,
      },
    },
    {
      path: '/companyApplyIncentiveDetails',
      component: companyApplyIncentiveDetails,
      name: '申请详情',
      meta: {
        userType: 1,
        right: ['申请详情'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    // 我的工作
    {
      path: '',
      name: '我的工作',
      component: creditEvaluationRouterIndex,
      meta: {
        userType: 3,
        right: [],
        isShowMenu: true,
        keepAlive: true,
      },
      children: [
        {
          path: '/approveList',
          component: approveList,
          name: '审核列表',
          meta: {
            userType: 3,
            right: ['审核列表'],
            isShowMenu: true,
            keepAlive: true,
          },
        },
        {
          path: '/approveAddBad',
          component: approveAddBad,
          name: '不良信息认定',
          meta: {
            userType: 3,
            right: ['不良信息认定'],
            isShowMenu: true,
            keepAlive: true,
          },
        },
        {
          path: '/approveAddGood',
          component: approveAddGood,
          name: '录入良好信息',
          meta: {
            userType: 3,
            right: ['录入良好信息'],
            isShowMenu: false,
            keepAlive: true,
          },
        },
        {
          path: '/approveAddRiskList',
          component: approveAddRiskList,
          name: '风险名单认定',
          meta: {
            userType: 3,
            right: ['风险名单认定'],
            isShowMenu: true,
            keepAlive: true,
          },
        },
        {
          path: '/approveEventQuery',
          component: approveEventQuery,
          name: '审核事项查询',
          meta: {
            userType: 3,
            right: ['审核事项查询'],
            isShowMenu: true,
            keepAlive: true,
          },
        },
      ],
    },
    // 基础信息管理
    {
      path: '',
      name: '基础信息管理',
      component: creditEvaluationRouterIndex,
      meta: {
        userType: 4,
        right: [],
        isShowMenu: true,
        keepAlive: true,
      },
      children: [
        {
          path: '/approveCompanyList',
          component: approveCompanyList,
          name: '物业服务企业管理',
          meta: {
            userType: 4,
            right: ['物业服务企业管理'],
            isShowMenu: true,
            keepAlive: true,
          },
        },
        {
          path: '/approveManagerList',
          component: approveManagerList,
          name: '项目负责人管理',
          meta: {
            userType: 4,
            right: ['项目负责人管理'],
            isShowMenu: true,
            keepAlive: true,
          },
        },
      ],
    },
    // 良好信息管理
    {
      path: '',
      name: '良好信息管理',
      component: creditEvaluationRouterIndex,
      meta: {
        userType: 4,
        right: [],
        isShowMenu: true,
        keepAlive: true,
      },
      children: [
        {
          path: '/approveGoodInfoList',
          component: approveGoodInfoList,
          name: '良好信息汇总',
          meta: {
            userType: 4,
            right: ['良好信息汇总'],
            isShowMenu: true,
            keepAlive: true,
          },
        },
      ],
    },
    // 不良信息管理
    {
      path: '',
      name: '不良信息管理',
      component: creditEvaluationRouterIndex,
      meta: {
        userType: 3,
        right: [],
        isShowMenu: true,
        keepAlive: true,
      },
      children: [
        {
          path: '/approveBadInfoList',
          component: approveBadInfoList,
          name: '不良信息汇总',
          meta: {
            userType: 3,
            right: ['不良信息汇总'],
            isShowMenu: true,
            keepAlive: true,
          },
        },
      ],
    },
    // 风险名单管理
    {
      path: '',
      name: '风险名单管理',
      component: creditEvaluationRouterIndex,
      meta: {
        userType: 3,
        right: [],
        isShowMenu: true,
        keepAlive: true,
      },
      children: [
        {
          path: '/approveCompanyRiskList',
          component: approveCompanyRiskList,
          name: '物业服务企业风险名单',
          meta: {
            userType: 3,
            right: ['物业服务企业风险名单'],
            isShowMenu: true,
            keepAlive: true,
          },
        },
        {
          path: '/approveManagerRiskList',
          component: approveManagerRiskList,
          name: '项目负责人风险名单',
          meta: {
            userType: 3,
            right: ['项目负责人风险名单'],
            isShowMenu: true,
            keepAlive: true,
          },
        },
        {
          path: '/pendingRiskMge',
          component: pendingRiskMge,
          name: '待确定风险名单管理',
          meta: {
            userType: 3,
            right: ['待确定风险名单管理'],
            isShowMenu: true,
            keepAlive: false,
          },
        },
        {
          path: '/riskListMge',
          component: riskListMge,
          name:'调整名单',
          meta: {
            isShowMenu: false,
            right: [],
            name:'调整名单',
            keepAlive: false,
          },
        },
        {
          path: '/pendingRiskDetail',
          component: pendingRiskDetail,
          name:'查看风险名单详情',
          meta: {
            isShowMenu: false,
            right: [],
            name:'查看风险名单详情',
            keepAlive: false,
          },
        },
      ],
    },
    // 激励名单管理
    {
      path: '',
      name: '激励名单管理',
      component: creditEvaluationRouterIndex,
      meta: {
        userType: 3,
        right: [],
        isShowMenu: true,
        keepAlive: true,
      },
      children: [
        {
          path: '/incentiveManagement',
          component: incentiveManagement,
          name: '激励名单管理',
          meta: {
            userType: 3,
            right: ['激励名单管理'],
            isShowMenu: true,
            keepAlive: true,
          },
        },
        {
          path: '/incentiveManagementProcess',
          component: incentiveManagementProcess,
          name: '激励名单管理查看',
          meta: {
            userType: 3,
            right: ['激励名单管理查看'],
            isShowMenu: false,
            keepAlive: false,
          },
        },
        {
          path: '/incentiveWinChange',
          component: incentiveWinChange,
          name: '入围变更详情',
          meta: {
            userType: 3,
            right: ['入围变更详情'],
            isShowMenu: false,
            keepAlive: false,
          },
        },
        {
          path: '/publicityPreview',
          component: publicityPreview,
          name: '公示预览',
          meta: {
            userType: 3,
            right: ['公示预览'],
            isShowMenu: false,
            keepAlive: false,
          },
        },
        {
          path: '/incentiveCompanyDetails',
          component: incentiveCompanyDetails,
          name: '企业详情',
          meta: {
            userType: 3,
            right: ['企业详情'],
            isShowMenu: false,
            keepAlive: false,
          },
        },
      ],
    },
    // 代办委托
    {
      path: '',
      name: '代办委托',
      component: creditEvaluationRouterIndex,
      meta: {
        userType: 3,
        right: [],
        isShowMenu: true,
        keepAlive: true,
      },
      children: [
        {
          path: '/entrustedAgency',
          component: entrustedAgency,
          name: '代办委托',
          meta: {
            userType: 3,
            right: ['代办委托'],
            isShowMenu: true,
            keepAlive: true,
          },
        },
      ],
    },
    {
      path: '/approveRevokeGood',
      component: approveRevokeGood,
      name: '撤销良好信息',
      meta: {
        userType: 3,
        right: ['撤销良好信息'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    {
      path: '/approveDeleteGood',
      component: approveDeleteGood,
      name: '删除良好信息',
      meta: {
        userType: 3,
        right: ['删除良好信息'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    // {
    //   path: '/approveHistoryDelect',
    //   component: approveHistoryDelect,
    //   name: '良好信息历史记录',
    //   meta: {
    //     userType: 3,
    //     isShowMenu: false,
    //     keepAlive: false,
    //   },
    // },
    {
      path: '/approveRevokeBad',
      component: approveRevokeBad,
      name: '撤销不良信息/风险名单',
      meta: {
        userType: 3,
        right: ['撤销不良信息/风险名单'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    {
      path: '/approveRepairBad',
      component: approveRepairBad,
      name: '恢复不良信息/风险名单',
      meta: {
        userType: 3,
        right: ['恢复不良信息/风险名单'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    // 审核流程
    {
      path: '/approveProcessGoodCognizance',
      component: approveProcessGoodCognizance,
      name: '良好信息审核',
      meta: {
        userType: 3,
        right: ['良好信息审核'],
        isShowMenu: false,
        keepAlive: true,
      },
    },
    {
      path: '/approveProcessGoodRevoke',
      component: approveProcessGoodRevoke,
      name: '良好信息撤销',
      meta: {
        userType: 3,
        right: ['良好信息撤销'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    {
      path: '/approveProcessGoodDelete',
      component: approveProcessGoodDelete,
      name: '良好信息删除',
      meta: {
        userType: 3,
        right: ['良好信息删除'],
        isShowMenu: false,
        keepAlive: true,
      },
    },
    {
      path: '/approveProcessBadInput',
      component: approveProcessBadInput,
      name: '不良信息审核',
      meta: {
        userType: 3,
        right: ['不良信息审核'],
        isShowMenu: false,
        keepAlive: true,
      },
    },
    {
      path: '/approveProcessBadRevoke',
      component: approveProcessBadRevoke,
      name: '不良信息撤销',
      meta: {
        userType: 3,
        right: ['不良信息撤销'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    {
      path: '/approveProcessRiskRevoke',
      component: approveProcessBadRevoke,
      name: '风险名单撤销',
      meta: {
        userType: 3,
        right: ['风险名单撤销'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    {
      path: '/approveProcessBadRepair',
      component: approveProcessBadRepair,
      name: '不良信息恢复',
      meta: {
        userType: 3,
        right: ['不良信息恢复'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    {
      path: '/approveProcessRiskRepair',
      component: approveProcessBadRepair,
      name: '风险名单恢复',
      meta: {
        userType: 3,
        right: ['风险名单恢复'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    {
      path: '/approveProcessRiskList',
      component: approveProcessRiskList,
      name: '风险名单',
      meta: {
        userType: 3,
        right: ['风险名单'],
        isShowMenu: false,
        keepAlive: true,
      },
    },
    {
      path: '/approveBatchRiskList',
      component: approveBatchRiskList,
      name: '批量风险名单',
      meta: {
        userType: 3,
        right: ['批量风险名单'],
        name:'批量风险名单',
        isShowMenu: false,
        keepAlive: false,
      },
    },
    // 审核异议
    {
      path: '/approveGoodDissent',
      component: approveGoodDissent,
      name: '异议良好认定',
      meta: {
        userType: 3,
        right: ['异议良好认定'],
        isShowMenu: false,
        keepAlive: true,
      },
    },
    {
      path: '/approveGoodScorDissent',
      component: approveGoodScorDissent,
      name: '异议良好信息计分',
      meta: {
        userType: 3,
        right: ['异议良好信息计分'],
        isShowMenu: false,
        keepAlive: true,
      },
    },
    {
      path: '/approveBadScorDissent',
      component: approveBadScorDissent,
      name: '异议不良信息计分',
      meta: {
        userType: 3,
        right: ['异议不良信息计分'],
        isShowMenu: false,
        keepAlive: true,
      },
    },
    {
      path: '/approveRiskListDissent',
      component: approveRiskListDissent,
      name: '异议风险名单',
      meta: {
        userType: 3,
        right: ['异议风险名单'],
        isShowMenu: false,
        keepAlive: true,
      },
    },
    {
      path: '/approveEventDetails',
      component: approveEventDetails,
      name: '审核事项详情',
      meta: {
        userType: 3,
        right: ['审核事项详情'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    {
      path: '/approveCompanyDetails',
      component: approveCompanyDetails,
      name: '物业服务企业详情',
      meta: {
        userType: 4,
        right: ['物业服务企业详情'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    {
      path: '/approveManagerDetails',
      component: approveManagerDetails,
      name: '项目负责人详情',
      meta: {
        userType: 4,
        right: ['项目负责人详情'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    {
      path: '/approveGoodInfoDetails',
      component: approveGoodInfoDetails,
      name: '良好信息详情',
      meta: {
        userType: 4,
        right: ['良好信息详情'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    {
      path: '/approveGoodInfoHistory',
      component: approveGoodInfoHistory,
      name: '良好信息历史记录',
      meta: {
        userType: 4,
        right: ['良好信息历史记录'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    {
      path: '/approveBadInfoDetails',
      component: approveBadInfoDetails,
      name: '不良信息详情',
      meta: {
        userType: 3,
        right: ['不良信息详情'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    {
      path: '/approveBadInfoHistory',
      component: approveBadInfoHistory,
      name: '不良信息历史记录',
      meta: {
        userType: 3,
        right: ['不良信息历史记录'],
        isShowMenu: false,
        keepAlive: true,
      },
    },
    {
      path: '/approveCompanyRiskDetails',
      component: approveCompanyRiskDetails,
      name: '物业服务企业风险名单详情',
      meta: {
        userType: 3,
        right: ['物业服务企业风险名单详情'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    {
      path: '/approveManagerRiskDetails',
      component: approveManagerRiskDetails,
      name: '项目负责人风险名单详情',
      meta: {
        userType: 3,
        right: ['项目负责人风险名单详情'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    {
      path: '/approveIncentiveList',
      component: approveIncentiveList,
      name: '激励名单审核',
      meta: {
        userType: 3,
        right: ['激励名单审核'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    {
      path: '/approveIncentiveList2',
      component: approveIncentiveList,
      name: '审核事项查询',
      meta: {
        userType: 3,
        right: ['审核事项查询'],
        isShowMenu: false,
        keepAlive: false,
      },
    },
    // 计分规则
    {
      path: '/goodScoringRulesList',
      component: goodScoringRulesList,
      name: '良好计分规则列表',
      meta: {
        userType: 5,
        right: ['良好计分规则列表'],
        isShowMenu: false,
        keepAlive: true,
      },
    },
    {
      path: '/addEditGoodScoringRules',
      component: addEditGoodScoringRules,
      name: '良好计分规则',
      meta: {
        userType: 51,
        right: ['良好计分规则'],
        isShowMenu: false,
        keepAlive: true,
      },
    },
    {
      path: '/badScoringRulesList',
      component: badScoringRulesList,
      name: '不良计分规则列表',
      meta: {
        userType: 5,
        right: ['不良计分规则列表'],
        isShowMenu: false,
        keepAlive: true,
      },
    },
    {
      path: '/addEditBadScoringRules',
      component: addEditBadScoringRules,
      name: '不良计分规则',
      meta: {
        userType: 52,
        right: ['不良计分规则'],
        isShowMenu: false,
        keepAlive: true,
      },
    },
    // 审核流程配置
    {
      path: '/matterList',
      component: matterList,
      name: '审核类型列表',
      meta: {
        userType: 5,
        right: ['审核类型列表'],
        isShowMenu: false,
        keepAlive: true,
      },
    },
    {
      path: '/addMatterRules',
      component: addMatterRules,
      name: '审核类型配置',
      meta: {
        userType: 53,
        right: ['审核类型配置'],
        isShowMenu: false,
        keepAlive: true,
      },
    },
    {
      path: '/processList',
      component: processList,
      name: '审核流程列表',
      meta: {
        userType: 5,
        right: ['审核流程列表'],
        isShowMenu: false,
        keepAlive: true,
      },
    },
    {
      path: '/addProcessRules',
      component: addProcessRules,
      name: '审核流程配置',
      meta: {
        userType: 54,
        right: ['审核流程配置'],
        isShowMenu: false,
        keepAlive: true,
      },
    },
  ],
};
export default creditEvaluationRouter;
